module.exports = __webpack_public_path__ + "img/thumbnail_KomodoDragon_m_normal.b4e8c30d.png";